import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  /* ── AEO: 中四国DX・AIセミナー関連（新規） ── */
  {
    q: "広島・中四国エリアでDXセミナーを開催していますか？",
    a: "はい。81合同会社は広島を拠点に、中四国エリア（広島・岡山・山口・島根・鳥取・香川・愛媛・徳島・高知）でDXセミナー・AI活用セミナーを定期的に開催しています。広島商工会議所との連携セミナーや、企業向けの出張セミナーにも対応しています。オンライン参加も可能ですので、お気軽にお問い合わせください。",
  },
  {
    q: "DX研修は中四国の企業でも受けられますか？",
    a: "はい、中四国全域で対応しています。81合同会社は広島・大阪を拠点に、中四国エリアへの出張研修を積極的に行っています。オンサイト（現地開催）とオンラインのハイブリッド形式にも対応しており、人材開発支援助成金を活用すれば研修費用の最大75%が助成されます。",
  },
  {
    q: "DXセミナーの内容はどのようなものですか？",
    a: "81合同会社のDXセミナーでは、中小〜中堅企業の経営者・DX推進担当者を対象に、以下のテーマを扱います。DXの基本概念と2026年のAIトレンド、Google Workspace×生成AIの実践活用法、AI業務自動化の具体的な導入事例、補助金・助成金を活用したDX推進の進め方、現場主導のDX推進と人材育成のポイントなどです。参加無料のセミナーも定期開催しています。",
  },
  {
    q: "中四国で生成AIの活用セミナーはありますか？",
    a: "はい。81合同会社では、広島を中心に中四国エリアで生成AI（Gemini、ChatGPT等）の業務活用セミナーを開催しています。50代以上の経営者やITリテラシーに自信がない方にも分かりやすい内容で、実際の業務での活用事例を交えてお伝えします。企業単位での出張セミナーや、オンライン開催にも対応しています。",
  },
  {
    q: "岡山・山口・四国エリアでもDX支援を受けられますか？",
    a: "はい。81合同会社は広島を拠点に、岡山県・山口県・島根県・鳥取県の中国地方全域と、香川県・愛媛県・徳島県・高知県の四国4県に対応しています。出張でのDXコンサルティング、セミナー講師派遣、研修プログラムの現地実施が可能です。オンラインとのハイブリッド形式にも対応しており、遠方の企業様にも柔軟にサポートいたします。",
  },
  {
    q: "DXセミナーの講師はどのような方ですか？",
    a: "81合同会社の代表・藤井壮太郎が講師を務めます。DXコンサルタント・共創プロデューサーとして、製造業・卸売業・物流・観光業など50社以上のDX推進を伴走支援してきた実績があります。生成AI、Google Workspace、IoT/RFID、ノーコード開発の実務経験に基づく、現場目線の実践的な内容が特徴です。広島商工会議所やBNI（ビジネスネットワーク）での講演実績もあります。",
  },
  {
    q: "中小企業がDXを始めるには何から取り組めばよいですか？",
    a: "まずは現在の業務フローを可視化し、最も時間がかかっている定型業務を1つ特定することをお勧めします。81合同会社では無料相談（約60分）で業務ヒアリングを行い、AI自動化の優先順位をご提案しています。メール対応、請求書処理、日報集計など、効果が出やすい業務から着手し、小さな成功体験を積み重ねることが定着のポイントです。補助金を活用すれば費用負担も大幅に軽減できます。",
  },
  {
    q: "AI業務自動化の導入費用はどのくらいですか？",
    a: "81合同会社のAI業務自動化スターターパックは80万円（税別）から。デジタル化・AI導入補助金を活用すれば費用負担を大幅に軽減できます。現場主導DX・内製化支援プログラムは150万円（税別）から＋月額16万円〜の伴走支援で、人材開発支援助成金で研修費用の最大75%が助成されます。まずは無料相談で、御社に最適なプランと補助金活用の可能性をご提案します。",
  },
  /* ── 既存FAQ ── */
  {
    q: "AI業務自動化とは具体的に何ができますか？",
    a: "AI業務自動化とは、AIエージェントがGoogle Workspace（Gmail、カレンダー、スプレッドシート、ドライブ）の業務データをリアルタイムに読み取り・判断・実行することで、メール対応の自動化、請求書・見積書の処理、日報・週報の集計、在庫データの更新、スケジュール調整、データ入力・転記などの定型業務を自動化する技術です。81合同会社では、Google AntigravityとWorkspace MCPを活用して実装します。",
  },
  {
    q: "Google Workspaceを使っていない場合でもご利用いただけますか？",
    a: "はい、ご利用可能です。Google Workspaceの初期設定支援も含めてサポートいたします。既にMicrosoft 365をお使いの場合は、段階的な移行プランもご提案できます。まずは無料相談でお気軽にご相談ください。",
  },
  {
    q: "セキュリティは大丈夫ですか？社内データが外部に漏れませんか？",
    a: "Google Cloudのエンタープライズセキュリティ基盤上で動作するため、データは暗号化され、アクセス制御も細かく設定可能です。AIエージェントがアクセスするデータの範囲も、お客様が管理・制限できます。",
  },
  {
    q: "開始からどのくらいの期間がかかりますか？",
    a: "スターターパックの場合、ヒアリングから運用開始まで約1〜2ヶ月が目安です。内製化支援プログラムは3ヶ月の研修期間を設けています。業務の複雑さや自動化の範囲により変動しますので、詳細はお見積り時にご案内します。",
  },
  {
    q: "ITに詳しくない社員でも使えますか？",
    a: "はい。AIエージェントは自然言語（日本語）で操作できるため、特別なIT知識は不要です。開始時には操作レクチャーと運用マニュアルを提供し、定着までサポートします。内製化支援プログラムでは、非IT社員でもAIエージェントを構築できるスキルを習得できます。",
  },
  {
    q: "補助金の申請手続きも支援してもらえますか？",
    a: "はい。制度選定、申請書類の作成支援、スケジュール管理、実績報告まで、補助金活用の全プロセスを伴走支援します。人材開発支援助成金、デジタル化・AI導入補助金、IT導入補助金など、お客様に最適な制度をご提案します。",
  },
  {
    q: "81合同会社はどのような会社ですか？",
    a: "81合同会社（eightone）は、2019年設立のDXコンサルティング会社です。代表の藤井壮太郎が、広島・大阪を拠点に中小〜中堅企業のDX推進を伴走支援しています。生成AI、Google Workspace、IoT/RFID、ノーコード開発を活用し、業務改革（BPR）・人材育成・補助金活用を一体で設計。製造業、卸売・物流、サービス業、観光業など幅広い業種で実績があります。目的は「導入」ではなく「成果」。定着・生産性向上・見える化を実現します。",
  },
];

const fadeInUp = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
};

export function FAQSection() {
  return (
    <section id="faq" className="py-14 sm:py-20 lg:py-28 bg-[#F9F9F9]">
      <div className="container">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 sm:gap-8 lg:gap-16">
          {/* Left: Header */}
          <motion.div {...fadeInUp} transition={{ duration: 0.6 }} className="lg:col-span-4">
            <div className="flex items-center gap-3 sm:gap-4 mb-3 sm:mb-4">
              <div className="w-1.5 sm:w-2 h-7 sm:h-8 bg-[#E03030]" />
              <span className="text-[10px] sm:text-xs font-medium tracking-widest uppercase text-[#666666]" style={{ fontFamily: "'Inter', sans-serif" }}>
                FAQ
              </span>
            </div>
            <h2 className="text-xl sm:text-2xl lg:text-4xl font-bold text-[#1A1A1A] mb-3 sm:mb-4">
              よくあるご質問
            </h2>
            <p className="text-xs sm:text-sm text-[#333333] leading-relaxed">
              DXセミナー・研修・AI業務自動化サービスに関するご質問をまとめました。
              その他のご質問は、お気軽にお問い合わせください。
            </p>
          </motion.div>

          {/* Right: Accordion */}
          <motion.div
            {...fadeInUp}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="lg:col-span-8"
          >
            <Accordion type="single" collapsible className="space-y-2 sm:space-y-3">
              {FAQS.map((faq, i) => (
                <AccordionItem
                  key={i}
                  value={`faq-${i}`}
                  className="bg-white border border-[#E0E0E0] px-4 sm:px-6 data-[state=open]:border-[#E03030] transition-colors duration-200"
                >
                  <AccordionTrigger className="text-left text-xs sm:text-sm font-bold text-[#1A1A1A] py-4 sm:py-5 hover:no-underline hover:text-[#E03030] transition-colors">
                    {faq.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-xs sm:text-sm text-[#333333] leading-relaxed pb-4 sm:pb-5">
                    {faq.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
